
import axios from "axios";

export const serviceApi = axios.create({
    baseURL: import.meta.env.VITE_SERVICE_URL ,
    timeout: 40000
  })

  export const erpMiddlewareApi = axios.create({
  baseURL: import.meta.env.VITE_ERP_MIDDLEWARE_URL ,
  timeout: 40000
})

export const validatorApi = axios.create({
  baseURL: import.meta.env.VITE_VALIDATOR_URL ,
  timeout: 40000
})

  export const remixApi = axios.create({
    baseURL: import.meta.env.VITE_REMIX_API_URL ,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const helper = axios.create({
  baseURL: import.meta.env.VITE_HELPER_API_URL ,
  timeout: 60000
  })

  export const helperV2 = axios.create({
  baseURL: import.meta.env.VITE_HELPER_V2_API_URL ,
  timeout: 50000
  })

export const utilityApi = axios.create({
  baseURL: import.meta.env.VITE_UTILITY_URL,
  timeout: 50000
})

export const ewayBillApi = axios.create({
    baseURL: import.meta.env.VITE_EWAY_BILL ,
    timeout: 40000
  })
